<template>
  <div class="index">
 <Title titleName='商家中心' iconLeft="back"/>

	<div class="mem-con">
		<div class="mem-l1">
			<van-row>
				<van-col span='6'>
					<img class="head" :src="user.avatar"/>
				</van-col>
				<van-col span='14'>
					<h3>  {{user.store_name}}</h3>
				
				</van-col>
				<van-col span='4' class="mem-sim" >
					<router-link to="/user/gift">
					
				
					<p>提现记录></p>
					
					</router-link>
				</van-col>
			</van-row>
		
		</div>
	
		

	</div>
	<div class="brave">
		<div class="win">
			<div class="leave">
				<div class="l3">
					<div class="nt">可提现 ￥{{user.store_info.balance}}</div><router-link to="/user/coupon">
					<div class="btn">申请提现</div></router-link>
				</div>
				<div class="l1">
					<ul><router-link to="/infos">
						<li>
							<h5>{{user.store_info.freeze_money}}</h5>
							<p>待结算（元）</p>
						</li></router-link>
						<li>
							<h5>{{user.store_info.settle_money}}</h5>
							<p>已结算（元）</p>
						</li>
						<li>
							<h5>{{user.store_info.balance}}</h5>
							<p>可提现（元）</p>
						</li>
					</ul>
				</div>
			
				<div class="l2">
					
					<div class="lab">接单模式</div>
					<div class="cid"><van-switch size="22" v-model="user.store_info.taking_mode" @change="mode" active-color="#FF5E00" inactive-color="#dcdee0" /></div>			
				</div>
				<router-link to="/user/pass">
				<div class="l2">
					
					<div class="lab">提现至</div>
					<div class="cid">设置支付宝账号<img src="../../assets/ip.png"></div>			
				</div></router-link>
				<router-link to="/user/cart">
				<div class="l2">
					
					<div class="lab">特约供应商</div>
					<div class="cid"><img src="../../assets/ip.png"></div>			
				</div></router-link>
			</div>
			<div class="far" style="background: #246ffe;color: white">
				<div class="l3">
					<van-tabs background="#246ffe" color="#ffffff" title-inactive-color="#ffffff" title-active-color="#ffffff" v-model="weight" :ellipsis="false">
					
						 <van-tab style="color: white" title="今日" name="1" ></van-tab>
						 <van-tab style="color: white" title="昨日" name="2" ></van-tab>
						 <van-tab style="color: white" title="本月" name="3" ></van-tab>
						 <van-tab style="color: white" title="全部" name="4" ></van-tab>
					</van-tabs>
				</div>
				<div class="l1">
					<ul v-if="weight==1">
						<li>
							<h5>{{user.store_info.tongji.todayMoney}}</h5>
							<p style="color: white">累计收益</p>
						</li>
						<li>
							<h5>{{user.store_info.tongji.todayNumber}}</h5>
							<p style="color: white">累计接单</p>
						</li>
						
					</ul>
					<ul v-if="weight==2">
						<li>
							<h5>{{user.store_info.tongji.yesterMoney}}</h5>
							<p style="color: white">累计收益</p>
						</li>
						<li>
							<h5>{{user.store_info.tongji.yesterNumber}}</h5>
							<p style="color: white">累计接单</p>
						</li>
						
					</ul>
					<ul v-if="weight==3">
						<li>
							<h5>{{user.store_info.tongji.monthMoney}}</h5>
							<p style="color: white">累计收益</p>
						</li>
						<li>
							<h5>{{user.store_info.tongji.monthNumber}}</h5>
							<p style="color: white">累计接单</p>
						</li>
						
					</ul>
					<ul v-if="weight==4">
						<li>
							<h5>{{user.store_info.tongji.totalMoney}}</h5>
							<p style="color: white">累计收益</p>
						</li>
						<li>
							<h5>{{user.store_info.tongji.totalNumber}}</h5>
							<p style="color: white">累计接单</p>
						</li>
						
					</ul>
				</div>
				
				
			</div>
			<div class="honor"></div>
		</div>
	</div>




  </div>
</template>
<script>
import Title from "@/common/title";
import { Toast } from 'vant';	
export default {
  components: {
    Title
  },
  data() {
    return {
		title:'',
		taking_mode:false,
		channel_id:0,
		images:[],
		info:'',
		user:'',
		weight:'',
		page:1,
		news:[],
		notice:[],
		name:'',
		hans:'',
		sfznum:'',
		phone:'',
		tip:''

    };
  },  mounted() {
 this.channel_id = this.$route.query.id;
 this.sandMate();
this.seat()
	this.sandMate();
		
		
		},methods: {
			mode() {
				
	          this.$axios({
	            method: "post",
	            url: "stores/mode",
	            data: {taking_mode:this.taking_mode}
	          }).then((res) => {
	          	let data=res.data;
	          			
	          	if(data.code==200){
	  						
	  			  Toast(data.message);
				
	    
	          		
	          	}else{  
	  			 Toast(data.message);
	  						      
	  			}
	           
	          });
	  				 
	  				 
	         
	       
	       },
			  seat(){
			  	this.user = JSON.parse(window.localStorage.getItem('user'));
			  
			  },sandAlt(){
				this.news=[]
				this.sandMate()
			
			}, blue(){
				
				
			this.$axios({
			      method: "post",
			      url: "stores/apply-withdraw",
			      data:{}
			    }).then((res) => {
			    	let data=res.data;
			    			
			    	if(data.code==200){
									
					
						Toast(data.message);
					
			    		
			    	}else{  
					Toast(data.message);
									      
								}
			     
			    });
				
				
				
				
			
			},sandMate(){
		
		this.$axios({
		  method: "post",
		  url: "stores/info",
		  data: {},  
		}).then((res)=>{
		    let data=res.data;
		    let user = JSON.parse(window.localStorage.getItem('user'));
		    if(data.code==200){
		    	data.data.store_info.token=user.token
		    	localStorage.setItem('user',JSON.stringify(data.data.store_info))
		    	this.user=data.data.store_info
				if(data.data.store_info.store_info.taking_mode==1){
					this.user.store_info.taking_mode=false
				}else{
					this.user.store_info.taking_mode=true
				}
		    	
		    
		    }
		 })
	
	}
		}
};
</script>
<style lang="scss" scoped>


 .mem-con{
 	 background: url(https://vkceyugu.cdn.bspapp.com/VKCEYUGU-dba7ffc8-6102-457c-8941-6212ed989b04/6c557c89-a107-489e-a719-2fb92b0fd379.png) no-repeat;
 	 background-size: 100%;
	 height: 200px;
 	 font-size: 24px;
 	 color: #fff;
 	 padding: 30px;
 	 .mem-l1{
 	
 		 padding: 40px 0;
 		 h3{
 			margin-top: 30px;
 			 font-size: 34px;
 			 color: #fff;
 		 }
 		 .head{
 			width: 100px;
			height: 100px;
			border-radius: 100px;
			margin-left: 30px;
 		 }
 		 .set{
 			 width: 42px;
 		 }
 		 .shop{
 			 width: 120px;
 			 height: 36px;
 			 border-radius: 18px;
 			 color: #7D7D7D;
 			 background: #fff;
 			 text-align: center;
 			 font-size: 24px;
 			 margin-top: 15px;
 		 }
 		 .mem-sim{
 			 text-align: center;
 			 margin-top: 30px;
 			
 			 p{
 				 color: #fff;
 			 }
 		 }
 		 
 	 }
 	
 }
 .h-button{
	 width: 230px;
	 height: 80px;
	 color: #7D7D7D;
	 display: flex;
	 border: 1px solid #7D7D7D;
	 border-radius: 40px;
	 justify-content: center;
	 align-items: center;
	 font-size:30px;
	 margin: 30px auto;
	 img{
		 width: 50px;
		 height:50px;
		 margin-right: 10px;
	 }
 }
.brave{

	width: 100%;
	margin-top: -50px;
	.win{
		width: 670px;
		margin: 0 auto;
		.leave{
			border-radius: 20px;
			background: #ffffff;
			padding: 0 50px;
			.l1{
				border-bottom: 1px solid #DDDDDD;
				padding: 40px 0;
				ul{
					display: flex;
					align-items: center;
					justify-content: space-between;
					li{
						text-align: center;
						h5{
							font-size: 34px;
							margin-bottom: 10px;
						}
						p{
							font-size: 24px;
							color: #999999;
						}
					}
				}
			}
			.l2{
				display: flex;
				justify-content: space-between;
				align-items: center;
				border-bottom: 1px solid #DDDDDD;
				height: 110px;
				.lab{
					color: #9f9f9f;
				}
				.cid{
					display: flex;
					align-items: center;
					img{
						width: 30px;
						height: 30px;
					}
				}
			}
			.l3{
				display: flex;
				justify-content: space-between;
				align-items: center;
				padding-top: 40px;
        // color: white;
        // background: #246ffe;
				.nt{
					font-size: 30px;
					display: flex;
					
				}
				.btn{
					width: 160px;
					height: 60px;
					background: #cfc3c3;
					border-radius: 40px;
					color: #222222;
					font-size: 28px;
					text-align: center;
					line-height: 60px;
				}
			}
		}
		.far{
			border-radius: 20px;
			background: #246ffe;
      //background: url(https://vkceyugu.cdn.bspapp.com/VKCEYUGU-dba7ffc8-6102-457c-8941-6212ed989b04/05b469df-ea5f-40f0-ba21-f048ed807595.png) no-repeat;
      background-size: 100%;
			padding: 0 50px;
			margin-top: 30px;
      color: white;
			.l1{
				border-bottom: 1px solid #DDDDDD;
				padding: 40px 0;
        background: #246ffe;
				ul{
					display: flex;
					align-items: center;
					justify-content: space-around;
					li{
						text-align: center;
						h5{
							font-size: 34px;
							margin-bottom: 10px;
						}
						p{
							font-size: 24px;
							color: #999999;
						}
					}
				}
			}
			.l2{
				display: flex;
				justify-content: space-between;
				align-items: center;
				border-bottom: 1px solid #DDDDDD;
				height: 110px;
				.cid{
					display: flex;
					align-items: center;
					img{
						width: 30px;
						height: 30px;
					}
				}
			}
		
		}
		.honor{
			h4{
				color: #222222;
				font-size: 28px;
				font-weight: normal;
				margin-top: 50px;
			}
		}
	}
}
.van-tabs__nav{
  background-color: #246ffe;
  color: white;
}
</style>